import { render } from "./ContactItem.vue?vue&type=template&id=edfd99a2&scoped=true&ts=true&lang=pug"
import script from "./ContactItem.vue?vue&type=script&lang=ts"
export * from "./ContactItem.vue?vue&type=script&lang=ts"

import "./ContactItem.vue?vue&type=style&index=0&id=edfd99a2&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfd99a2"]])

export default __exports__